export default function wpAccordion() {
    /*==============
    Accordion
    ==============*/
// Show first Element
    if (document.querySelector(".accordion .wp-block-heading")) {
        let firstPanel = document.querySelector(".accordion .wp-block-heading").nextElementSibling;
        let firstHeading = document.querySelector(".accordion .wp-block-heading");
        firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
        firstHeading.classList.add('active');
        firstPanel.classList.add('active');
        if (!firstHeading) {
            console.log('no');
        }
        [...document.querySelectorAll(".accordion .wp-block-heading")].forEach(accordion => {
            // add class name to heading for further adjustment
            accordion.classList.add("accordion-heading");
            accordion.nextElementSibling.classList.add("accordion-panel");

            accordion.addEventListener("click", function() {
                var panel = this.nextElementSibling;
                panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + "px";
                if (this.classList.contains('active')) {
                    this.classList.remove('active');
                    panel.classList.remove('active');
                } else {
                    this.classList.add('active');
                    panel.classList.add('active');
                }
            })
        })
    }

}
